const config = {
    API_KEY :" 9633e17bff0c4a648d5142404242501",
};
export default config;